import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseRequestOptions, HttpModule } from '@angular/http';
import { ResetPasswordComponent } from './resetpassword.component';
import { AuthGuard } from './../../auth/_guards/auth.guard';
import { AlertService } from './../../auth/_services/alert.service';
import { AuthenticationService } from './../../auth/_services/authentication.service';
import { UserService } from './../../auth/_services/user.service';
import { appService } from './../../_services/app.service';
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { ResetPasswordRoutingModule } from "./resetpassword-routing.routing";
import {
    TranslateLoader,
    TranslateModule,
    TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
    declarations: [
        ResetPasswordComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ResetPasswordRoutingModule,
        HttpModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    providers: [
        AlertService,
        AuthenticationService,
        appService,
        UserService,
        BaseRequestOptions,
        TranslateConfigService
    ],
    entryComponents: [],
})

export class ResetPasswordModule {

}